import type { WebhookHeader } from '../types';
import { WebhookSubscriptionTopicEnum } from '../types';

export const topicOptions = [
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_CREATED,
    label: 'Booking created'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_CLIENT_REFERENCE_CHANGED,
    label: 'Booking client reference changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_INCOTERMS_CHANGED,
    label: 'Booking incoterms changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_MODE_OF_TRANSPORT_CHANGED,
    label: 'Booking mode of transport changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_CONSIGNEE_CHANGED,
    label: 'Booking consignee changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_CONSIGNOR_CHANGED,
    label: 'Booking consignor changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_TRADE_LANE_CHANGED,
    label: 'Booking trade lane changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_TRADE_ROLE_CHANGED,
    label: 'Booking trade role changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_SHIPMENT_TYPE_CHANGED,
    label: 'Booking shipment type changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_TRUCK_SWAP_CHANGED,
    label: 'Booking truck swap changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_COLLECTION_ADDRESS_CHANGED,
    label: 'Booking collection address changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_DELIVERY_ADDRESS_CHANGED,
    label: 'Booking delivery address changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_HOUSE_BOL_CHANGED,
    label: 'Booking house BOL changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_SPECIAL_INSTRUCTIONS_CHANGED,
    label: 'Booking special instructions changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_CARGO_MODE_CHANGED,
    label: 'Booking cargo mode changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_NETWORKS_ORIGIN_ASSIGNED,
    label: 'Booking networks origin assigned'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_NETWORKS_DESTINATION_ASSIGNED,
    label: 'Booking networks destination assigned'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_VALUE_OF_GOODS_ADDED,
    label: 'Booking value of goods added'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_TOTAL_VALUE_CHANGED,
    label: 'Booking total value changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_QUOTE_WON,
    label: 'Booking quote won'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_QUOTE_LOST,
    label: 'Booking quote lost'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_QUOTE_LOST_REASON_CHANGED,
    label: 'Booking quote lost reason changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_REQUEST_CANCELLED,
    label: 'Booking request cancelled'
  },
  {
    value: WebhookSubscriptionTopicEnum.BOOKING_CANCELLATION_REASON_CHANGED,
    label: 'Booking cancellation reason changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_CONTAINER_ADDED,
    label: 'Cargo container added'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_LOOSE_CARGO_ADDED,
    label: 'Cargo loose cargo added'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_VEHICLE_ADDED,
    label: 'Cargo vehicle added'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_CONTAINER_UPDATED,
    label: 'Cargo container updated'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_LOOSE_CARGO_UPDATED,
    label: 'Cargo loose cargo updated'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_VEHICLE_UPDATED,
    label: 'Cargo vehicle updated'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_ITEM_REMOVED,
    label: 'Cargo item removed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_ITEM_ARCHIVED,
    label: 'Cargo item archived'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_VOLUME_CHANGED,
    label: 'Cargo volume changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_WEIGHT_CHANGED,
    label: 'Cargo weight changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_HAZARDOUS_CHANGED,
    label: 'Cargo hazardous changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_QUANTITY_CHANGED,
    label: 'Cargo quantity changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_REEFER_CHANGED,
    label: 'Cargo reefer changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_CONTAINER_TYPE_CHANGED,
    label: 'Cargo container type changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_CONTAINER_SEAL_CHANGED,
    label: 'Cargo container seal changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_CONTAINER_SPECIAL_CHANGED,
    label: 'Cargo container special changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_CHARGEABLE_WEIGHT_CHANGED,
    label: 'Cargo chargeable weight changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_PALLET_TYPE_CHANGED,
    label: 'Cargo pallet type changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_STACKABLE_CHANGED,
    label: 'Cargo stackable changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_DIMENSIONS_CHANGED,
    label: 'Cargo dimensions changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_VEHICLE_TYPE_CHANGED,
    label: 'Cargo vehicle type changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_VEHICLE_DIMENSIONS_CHANGED,
    label: 'Cargo vehicle dimensions changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_VEHICLE_HEALTH_CERT_CHANGED,
    label: 'Cargo vehicle health certificate changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_VEHICLE_TAIL_LIFT_CHANGED,
    label: 'Cargo vehicle tail lift changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_VEHICLE_TRAILER_CHANGED,
    label: 'Cargo vehicle trailer changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_VEHICLE_RISK_LEVEL_CHANGED,
    label: 'Cargo vehicle risk level changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_CONTAINER_CONFIGURATION_CHANGED,
    label: 'Cargo container configuration changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.CARGO_CONTAINER_NUMBER_CHANGED,
    label: 'Cargo container number changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.LOT_BOOKED,
    label: 'Lot booked'
  },
  {
    value: WebhookSubscriptionTopicEnum.LOT_QUANTITY_CHANGED,
    label: 'Lot quantity changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.PURCHASE_ORDER_CARGO_READY_DATES_CHANGED,
    label: 'Purchase order cargo ready dates changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.PURCHASE_ORDER_CLOSED,
    label: 'Purchase order closed'
  },
  {
    value: WebhookSubscriptionTopicEnum.PACKING_LIST_LINES_CHANGED,
    label: 'Packing list lines changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.SHIPMENT_DELIVERY_ESTIMATE_CHANGED,
    label: 'Shipment delivery estimate changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.SHIPMENT_SAILING_SCHEDULE_CHANGED,
    label: 'Shipment sailing schedule changed'
  },
  {
    value: WebhookSubscriptionTopicEnum.SHIPMENT_STAGE_CHANGED,
    label: 'Shipment stage changed'
  }
];

export const emptyHeader: WebhookHeader = {
  name: '',
  value: ''
};
